import { CURRENT_ENV, ENV } from "./features";

const SHARE_POINT_TEMPLATE_FOLDER_LINK_BY_ENV: { [k: string]: string } = {
  [ENV.LOCAL]: process.env.REACT_APP_LOCAL_SHARE_POINT_TEMPLATE_FOLDER || "",
  [ENV.DEV]: process.env.REACT_APP_DEV_SHARE_POINT_TEMPLATE_FOLDER || "",
  [ENV.QA]: process.env.REACT_APP_QA_SHARE_POINT_TEMPLATE_FOLDER || "",
  [ENV.PREPROD]:
    process.env.REACT_APP_STAGING_SHARE_POINT_TEMPLATE_FOLDER || "",
  [ENV.PROD]: process.env.REACT_APP_PROD_SHARE_POINT_TEMPLATE_FOLDER || "",
};

export const SHARE_POINT_TEMPLATE_FOLDER_LINK =
  SHARE_POINT_TEMPLATE_FOLDER_LINK_BY_ENV[CURRENT_ENV];
